( function( window, document, $ ) {
    'use strict';

    // --------------------------------------------------
    // EVENTS
    // --------------------------------------------------
    $( window ).on( 'load', function() {
        // Add 'window load' logic here.
    } );

    $( document ).ready( function() {
        if ( typeof objectFitImages === 'function' ) {
            // Function can take options (https://github.com/bfred-it/object-fit-images#usage); but this should do it in most cases
            objectFitImages();
        }

        // Add DOM-related logic here.
        var customSelects = window.customSelect( '.custom-select, .form-dropdown' );
        for ( customSelect of customSelects ) {
            customSelect.opener.removeAttribute( 'aria-autocomplete' );
            customSelect.opener.setAttribute( 'role', 'listbox' );
            if ( customSelect.select.labels.length > 0 ) {
                customSelect.panel.setAttribute( 'aria-labelledby', customSelect.select.labels[0].id );
            }
        }

        // Customize file upload element(s) in form(s)
        $( '.form-upload, .form-upload-multiple' ).each( stylizeFileUpload );

        initJotform();

    } );

    $( window ).on( 'scroll', scrollEventHandler );

    $( window ).on( 'resize', resizeEventHandler );


    // --------------------------------------------------
    // DECLARE FUNCTIONS
    // --------------------------------------------------
    /**
    * Wrapper around *any* logic which should be triggered on window scroll.
    */
    function scrollEventHandler( e ) {
        // Add 'window scroll' logic here.
    }

    /**
    * Wrapper around *any* logic which should be triggered on window resize.
    */
    function resizeEventHandler( e ) {
        // Add 'window resize' logic here.
    }

    /**
    * Stylize file upload elements.
    */
    function stylizeFileUpload( i, e ) {
        const filePlaceHolder = 'Choose a File';
        var realInput = $( this );
        var customInput = $( '<div>' ).addClass( 'custom-file-upload-container' ).html( `
                <span class="file-info">No file chosen</span>
                <button class="upload-button">${filePlaceHolder}</button>
        ` );
        realInput.addClass( 'custom-file-upload-input' ).after( customInput );

        // Handle custom upload button
        customInput.find( '.upload-button' ).click(  ( e ) => {
            e.stopPropagation();
            e.preventDefault();
            realInput.click();
        } );

        // Update custom UI with real element
        realInput.on( 'change', ( e ) => {
            const fileName = realInput.val().split( /\\|\// ).pop();
            customInput.find( '.file-info' ).html( fileName ? fileName : filePlaceHolder );
        } );
    }

    /**
    * Javascript functions for Jotform forms.
    * (Do not import any Jotform Javascript with the form itself)
    */
   function initJotform( i, e ) {

       // Update text area limit
       $( '.form-textarea-limit textarea' ).on( 'keyup', function() {
           $( this ).siblings( '.form-textarea-limit-indicator' ).children( 'span' ).text(
               this.textLength + '/' + this.maxLength
           );
       } );

       // Update payment totals
       $( '.form-product-item input' ).on( 'change', function() {
            let price = $( '#' + $( this ).attr( 'id' ) + '_price' ).text().trim();
            if( price ) {
                price = parseFloat( price.replace( ',', '' ) ).toFixed( 2 );
                $( '#payment_subtotal' ).text( price );
                $( '#payment_tax' ).text( ( price * 0.13 ).toFixed( 2 ) );
                $( '#payment_total' ).text( ( price * 1.13 ).toFixed( 2 ) );
            }
        } );
    }

} )( window, document, jQuery );
